export enum type {
    USER_VIEW_ONLY_INIT = 'USER_INUSER_VIEW_ONLY_INITIT',
    USER_VIEW_ONLY_INIT_ASYNC = 'USER_VIEW_ONLY_INIT_ASYNC',
    GET_TEACHER_VIDEO_VIEW_ONLY_LIST = 'GET_TEACHER_VIDEO_VIEW_ONLY_LIST',
    GET_TEACHER_VIDEO_VIEW_ONLY_LIST_ASYNC = 'GET_TEACHER_VIDEO_VIEW_ONLY_LIST_ASYNC',
}
